<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý vật tư - dịch vụ</div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="list-title">
            <span class="p-m-0">Danh sách vật tư - dịch vụ</span>
            <span class="p-input-icon-left" v-if="checkVisible('service_supplies', 'add')">
              <Button
              :label="'Tạo mới'"
                type="button"
                v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo mới'}, key: 'add'})"
              > </Button>
            </span>
          </div>
        </div>
        <BaseCommon v-if="dataModel && checkVisible('service_supplies', 'list')"
          :key="componentKey"
          :listData="listData"
          :model="dataModel"
          :filterDefault="filters"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
        ></BaseCommon>
      </div>
      <Popup
        v-if="editDialogKey > 0"
        :key="editDialogKey"
        :show="displayDialog"
        :mode="dialogMode"
        :model="modelEdit"
        :modelName="modelName"
        :screen="'service_supplies'"
        @refresh="refreshData"
      ></Popup>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import Popup from './popup'
export default {
  components: {
    BaseCommon,
    Popup
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      modelName: '',
      componentKey: 0,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      modelEdit: {}
    }
  },
  mounted () {
    this.initData();
    
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    initData() {
      setTimeout(async () => {
        //if (this.checkVisible('service_supplies', 'list')) {
          await this.initParams();
       // }
      }, 1000);
    },
    async initParams() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.filters = {};
      this.modelName = 'service_supplies';
      var variables = {
        where_key: {
          status: {'_in': [0,1] }
        },
        orderBy: {
          id: 'desc'
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      this.listData = list;
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    getRowActions() {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', label: 'Tạo mới'};
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if(that.checkVisible('service_supplies', 'edit')) {
          if (creator_organization_id == rowData.creator_organization_id){
            buttons.edit = { name: 'edit', icon: 'pencil', key: 'id'}
            //  buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
            if (that.dataModel.actions) {
              var modelaction = that.dataModel.actions(rowData)
              Object.assign(buttons, modelaction);
            }
          }
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          if (this.checkVisible('service_supplies', 'add')) {
            this.dialogMode = action.name
            if (action.path !== undefined && action.path) {
              this.$router.push({ path: action.path})
            } else  {
              this.displayDialog = true
              this.editDialogKey = Math.floor(Math.random() * (30))
            }
          }
          break;
        case 'edit':
          if (this.checkVisible('service_supplies', 'edit')) {
            this.dialogMode = action.name
            if (action.path !== undefined && action.path) {
              this.$router.push({ path: action.path + data.data[action.key] })
            } else  {
              this.modelEdit = data.data;
              this.displayDialog = true
              this.editDialogKey = Math.floor(Math.random() * (30));
            }
          }
          break;
      }
      
    },
    refreshData(){
      this.initParams();
    }
  }
}
</script>

<style lang="scss">
td.right_td_unit_price{
  text-align: right !important;
}
</style>